import { SingletonSessionState } from '@reducers/singletonSession';
import type { Selector } from '@types';

// eslint-disable-next-line import/prefer-default-export
export const getSessionState: Selector<
  SingletonSessionState['state']
> = state => state.singletonSession.state;
